const root = "Header-module_root_Pe4MYpPz";
const skip = "Header-module_skip_RE2tmHaz";
const logo = "Header-module_logo_xO2bWOoS";
const styles = {
  root,
  skip,
  logo
};
export {
  styles as default,
  logo,
  root,
  skip
};
